<template>
  <div class="analysis">
    <div class="top wbg" v-if='$common.AUTH("statis:credit:lists")'>
      <a-row class="row" :gutter="40">
        <a-col :span='6' class="flex">
          <label>委托类型：</label>
          <a-select placeholder="请选择" class="select">
            <a-select-option :value="1">委托代理</a-select-option>
            <a-select-option :value="2">委托管理</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>案件类型：</label>
          <a-select v-model="form.cause_type" placeholder="请选择"  class="select" allowClear>
            <!-- <a-select-option :value="0" disabled>调解</a-select-option> -->
            <a-select-option :value="2">调解</a-select-option>
            <a-select-option :value="1">诉讼</a-select-option>
            <a-select-option :value="3" disabled>公证执行</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>原告：</label>
          <a-select v-model="form.accuser_id" placeholder="请选择" mode="multiple" :maxTagCount='1' :maxTagTextLength='12' allowClear  class="select" :filter-option="$common.filterOption">
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>管辖法院：</label>
          <a-select v-model="form.court_id" placeholder="请选择" mode="multiple" :maxTagCount='1' :maxTagTextLength='14' @search="handleSearch" :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"  class="select"
            allowClear>
            <a-select-option v-for="item in courtList" :key="item.title" :value="item.id">{{ item.title }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row class="row" :gutter="40">
         <!-- <a-col :span="4" class="flex" style="padding-right: 0;">
             <a-radio-group v-model="type">
              <a-radio :value="1" >回款日期</a-radio>
              <a-radio :value="2" >分期日期</a-radio>
            </a-radio-group>
        </a-col> -->
          <a-col :span="6" class="flex">
            <label>还款日期：</label>
            <timePick @PickTime="PickTime" ref="timePicker"></timePick>
          </a-col>
          <a-col :span="8" class="flex">
          <a-button icon="search" type='primary' style="height:32px;" @click="search">查询</a-button>
          <a-button style="height:32px;margin-left: 20px;" @click="reset">重置</a-button>
          <a-button icon="upload" type='primary' ghost style="height:32px;margin-left:20px;" @click="out(1)" v-if='$common.AUTH("export:fqxxb")'>导出</a-button>
          </a-col>
        </a-row>
    </div>
    <div class="conmains">
      <div class="h2">案件分期统计</div>
      <div class="con">
        <!-- <div class="li"><div class="tit">待还款总额(元)</div><div class="p">{{ static.sum  | showYuan}}</div></div> -->
        <div class="li"><div class="tit">当前分期总额(元)</div><div class="p">{{ allMoney(static.list,[8,4,1,5,9]) | showYuan}}</div></div>
        <div class="li"><div class="tit">本金分期总额(元)</div><div class="p">{{ moneyKey(static.list,8) | showYuan}}</div></div>
        <div class="li"><div class="tit">律师费分期总额(元)</div><div class="p">{{ moneyKey(static.list,4) | showYuan }}</div></div>
        <div class="li"><div class="tit">诉讼费分期总额(元)</div><div class="p">{{ moneyKey(static.list,1) | showYuan}}</div></div>
        <div class="li"><div class="tit">差旅费分期总额(元)</div><div class="p">{{ moneyKey(static.list,5) | showYuan}}</div></div>
        <div class="li"><div class="tit">利息分期总额(元)</div><div class="p">{{ moneyKey(static.list,9) | showYuan}}</div></div>
    
      </div>
    </div>
    <div class="botmains">
      <div class="tableList" v-if='$common.AUTH("statis:credit:lists")'>
        <div class="table">
          <table>
            <thead>
              <td width='40'>序号</td>
              <td width='72'>债务人</td>
              <td width='130'>债务人证件号码</td>
              <td width='80'>所属案件</td>
              <td width='180'>原告</td>
              <td width="120">当期应还款金额</td>
              <td width='120'>未还款金额</td>
              <td width='140'>分期总额</td>
              <td width='80' >还款状态</td>
            </thead>
            <tbody>
              <tr v-for='(i,index) in data' :key='index'>
                  <td>{{index+1+(10*(formPage.page-1))}}</td>
                  <td><span class="curpoter" @click='dbclick(i)'>
                      <Normap :tit='i.realname'>{{i.realname}}</Normap>
                    </span></td>
                  <td>
                    <Normap :tit='i.chinaid'>{{i.chinaid}}</Normap>
                  </td>
                  <td>
                    <p v-for='j in i.cause'>
                      案件{{j.sort}}
                    </p>
                  </td>
                  <td>
                    <p v-for='j in i.cause'>
                      <Normap :tit='j.accuser.title || "/"' v-if="j.accuser">{{j.accuser.title || '/'}}</Normap>
                    </p>
                  </td>
              
                  <td>
                    <p v-for='j in i.cause'>
                      {{ j.payee_fee | showYuan }}
                      <!-- <Normap :tit='getSp(j.court)[1]'>{{getSp(j.court)[1]}}</Normap> -->
                    </p>
                  </td>
                  <td>
                    <p v-for='j in i.cause'>
                      {{(j.loan_fee - j.payee_fee) | showYuan}}
                    </p>
                  </td>
                  <td>
                    <p v-for='j in i.cause'>
                      {{j.loan_fee | showYuan}}
                    </p>
                  </td>
                  <td>
                    <p v-for='j in i.cause'>
                      
                      
                        <span class="status ing" v-if='j.loan.length && j.loan[0].status==1'>待还款</span>
                        <span class="status succ" v-if='j.loan.length && j.loan[0].status==2'>已还款</span>
                        <span class="status err" v-if='j.loan.length && j.loan[0].status==3'>已逾期</span>
                        <span class="status oky" v-if='j.loan.length && j.loan[0].status==4'>已申请执行</span> 
                        <span v-if="j.loan && j.loan.length==0">/</span>
                    </p>
                  </td>
                </tr>
            </tbody>
          </table>
        </div>
        <div class="pages">
          <a-pagination v-model="formPage.page" show-quick-jumper :total="total" show-less-items :pageSize='10'  @change='turnpage' :show-total="(total) => `小计：${total} `" />
        </div>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
  import {getAccuserAll} from '@/server/api'
  import {getDirectory } from "@/server/directory"
  import { feeList,defeeList } from '@/server/debtor'
  import { exportForm } from '@/assets/js/unit'
  export default {
    data() {
      return {
        static: {
          total:0,
          list: [],
        },
        type: 1,
        courtList: [], //法院
        accuserList: [],
        form: {
          accuser_id: [],
          cause_type: undefined,
        },
        formPage: {
          page: 1,
          limit: 10
        },
        data: [],
        total: 0
      }
    },
    created() {
      getAccuserAll().then((res) => {
        this.accuserList = res.list
      })
      this.search()
    },
    methods: {
      dbclick(record) {
        if (this.$common.AUTH('debtor:info')) {
          let routeUrl = this.$router.resolve({
            "name": "lydetails",
            params: {
              "id": record.id
            }
          });
          window.open(routeUrl.href, '_blank');
        } else {
          this.$message.error({
            content: '暂无权限',
            key: 'updatable'
          });
        }
      },
      allMoney(data,key){
        if(data.length>0){
          return data.filter(ele=>{return key.indexOf(ele.type)>=0}).reduce((prev,next)=>{return prev+next.fee*1},0)
        }
        else return 0
      },
      moneyKey(data, key) {
        const sumsData = data.find(ele => { 
          return ele.type == key
        })
        return sumsData ? sumsData.fee : '-'
      },
      getList() {
        const form = JSON.parse(JSON.stringify(this.form))
        form.accuser_id = form.accuser_id.toString()
        defeeList(Object.assign(form, this.formPage)).then(e => {
          this.data = e.list;
          this.total = e.count
        })
      },
      search() {
        let form = JSON.parse(JSON.stringify(this.form))
        form.accuser_id = form.accuser_id.toString()
        feeList(form).then(e => {
          this.static=e;
        })
        this.formPage.page = 1;
        this.getList()
      },
      reset(){
        this.form.cause_type = undefined
        this.form.accuser_id = []
        this.form.court_id = []
        this.form.loan_period_stime = ''
        this.form.loan_period_etime = ''
        this.$refs.timePicker.clearTime()
        this.search()
      },
      turnpage(val) {
        this.formPage.page = val;
        this.getList()
      },
      PickTime(e) {
        if ("stime" in e) {
          this.form.loan_period_stime = e.stime
        } else {
          this.form.loan_period_etime = e.etime
        }
      },
      out(type) {
        const form = JSON.parse(JSON.stringify(this.form));
        exportForm(type,form)   
      },
      handleSearch(val) {
        getDirectory({
          limit: 100,
          title: val
        }).then((res) => {
          this.courtList = res.list
        })
      },
    }
  }
</script>
<style lang="less" scoped>
  .contbox {
    display: flex;
    width: 510px;
    box-sizing: border-box;
    background: #ffffff;
    flex-wrap: wrap;
    p {
      font-size: 14px;
      margin-bottom: 0;
      line-height: 30px;
      margin-right: 20px;
    }
  }
  @import url('@/assets/css/search.less');
  .h2 {
    line-height: 62px;
    padding-left: 20px;
    font-size: 16px;
    color: #0e2949;
    font-weight: bold;
    border-bottom: 1px solid #efefef;
  }
  .wbg {
    margin-bottom: 10px;
  }
  .conmains {
    background: #fff;
    .con {
      height: 105px;
      display: flex;
      background: #F6F8FC;
      margin: 20px 20px 0;
      .li {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 15%;
        flex-direction: column;
        &:nth-last-child(1) {
          width: 10%;
        }
        .tit {
          font-size: 14px;
          font-weight: 500;
          color: #0E2949;
          line-height: 20px;
        }
        .p {
          font-size: 14px;
          font-weight: 500;
          margin-top: 5px;
          color: #0E2949;
          line-height: 20px;
        }
      }
    }
  }
  .botmains {
    background: #fff;
    .tableList {
      padding: 20px;
      .table {
        thead {
          td {
            padding-left: 0;
            &:nth-child(1) {
              padding-left: 20px;
            }
          }
        }
        tbody {
          tr:nth-last-child(1) {
            border-bottom: 1px solid #ebebeb;
          }
          td {
            padding: 6px 0;
            height: 60px;
            &:nth-child(1) {
              padding-left: 20px;
            }
            p {
              padding: 10px 0;
              margin: 0;
              border-bottom: 1px solid #ebebeb;
              &:nth-last-child(1) {
                border: 0 none;
              }
            }
          }
        }
      }
    }
  }
</style>